import React from "react";
import { Card, Descriptions, PageHeader, Button } from "antd";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const ViewPassportData = (props) => {
  const handleDownloadPDF = () => {
    const element = document.getElementById("view-profile");
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("PassportDetails.pdf");
    });
  };
  console.log("props", props);

  return (
    <div id="view-profile">
      <div style={{ padding: "20px 0" }}>
        <PageHeader
          onBack={false}
          title="Passport Details"
          extra={[
            <Button type="primary" onClick={handleDownloadPDF}>
              Download PDF
            </Button>,
          ]}
        >
          <Card className="viewCard">
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">File Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.file_number
                    ? props?.data?.file_number
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Name</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.full_name
                    ? props?.data?.full_name
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">DOB</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.dob
                    ? moment(props?.data?.dob).format("DD/MM/YYYY")
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Passport Number</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.passport_number
                    ? props?.data?.passport_number
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Date of Application</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.date_of_application
                    ? props?.data?.date_of_application
                    : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Application Type</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.application_type
                    ? props?.data?.application_type
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Status</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.status
                    ? props?.data?.status
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions
              size="small"
              column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}
            >
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Reason</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.type ? props?.data?.type : "-"}
                </div>
              </Descriptions.Item>
              <Descriptions.Item
                style={{ fontWight: "bold" }}
                label={<span className="sub-heading">Details</span>}
              >
                <div style={{ fontSize: 16 }}>
                  {props.data && props?.data?.details
                    ? props?.data?.details
                    : "-"}
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </PageHeader>
      </div>
    </div>
  );
};
